import { QueryKey } from '@/configs/queryKeys';
import { ComponentVariation } from './ComponentVariationApi';
import { SerializedCreator } from '@/types/creator';
import { Attachment, UUID } from '@/types/types';
import { ProductType } from './ProductTypeApi';
import { User } from '@/types/user';
import { SelectedMontageType } from './ProjectApi';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export interface ProjectTemplate extends BaseEntity {
	name: string;
	user: User;
	componentVariations: ComponentVariation[];
	productType: Partial<ProductType>;
	productTypeId: UUID;
	selectedMontageType: SelectedMontageType;
	serializedCreator: SerializedCreator;
	image?: Attachment;
}

class ProjectTemplateApi extends EntityApi<ProjectTemplate> {
	constructor() {
		super(QueryKey.projectTemplates);
		this.clone = this.clone.bind(this);
		this.createFromProject = this.createFromProject.bind(this);
	}

	async clone(id: UUID) {
		const response = await httpClient.post<ProjectTemplate>(
			`/${this.queryKey}/${id}/clone`
		);

		return response.data;
	}

	async createFromProject({
		projectId,
		name,
	}: {
		projectId: UUID;
		name: string;
	}) {
		const response = await httpClient.post<ProjectTemplate>(
			`/${this.queryKey}/from-project`,
			{
				projectId,
				name,
			}
		);

		return response.data;
	}
}

export default new ProjectTemplateApi();
